<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
    <el-form-item label="用户名（登录）" prop="username">
      <el-input v-model="ruleForm.username" placeholder="请输入用户名（登录）" style="width: 300px;float: left"></el-input>
    </el-form-item>

    <el-form-item label="姓名" prop="name">
      <el-input  v-model="ruleForm.name" placeholder="请输入姓名" style="width: 200px;float: left"></el-input>
    </el-form-item>

    <el-form-item label="角色" prop="roleID">
      <el-select v-model="ruleForm.roleID" placeholder="请选择添加用户的角色" style="float: left; width: 200px">
        <el-option v-for="item in allrole"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      <el-button @click="resetForm('ruleForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {getallrole,insertUser} from "../../axios";

export default {
  name: "newuser",
  props:['userid','username','realname','role','companyID','usercompany'],
  data() {
    return {
      allrole: [{
        label: '客户',
        value: 3
      }],
      ruleForm: {
        username: '',
        name: '',
        roleID: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入用户姓名', trigger: 'change' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        roleID: [
          { required: true, message: '请选择用户的角色', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    this.getallrole();
  },
  methods: {
    getallrole(){  //得到所有角色信息
      getallrole().then(res =>{
        this.allrole = res.data;
      }).catch(err =>{
        console.log(err);
      })
    },
    submitForm(formName) {  //提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          insertUser(this.ruleForm).then(res =>{
            this.$message.success(res);
            // console.log(this.ruleForm);
            if(res == '插入成功'){
              this.ruleForm.name = '';
              this.ruleForm.roleID = '';
              this.ruleForm.username = '';
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {  //重置表单
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>

</style>
